<template>
	<div :class="classNames">
		<div :class="classNames+ '_search'">
			<div :class="classNames+ '_search_con'">
				<div :class="classNames+ '_search_con_item'" style="width:260px;">
					<span :class="classNames+ '_search_con_item_title'">订单编号</span>
					<el-input placeholder="" v-model="searchObj.order_no"></el-input>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">支付时间</span>
					<!-- <el-date-picker v-model="times" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期" @change="changeTime" value-format="yyyy-MM-dd">
					</el-date-picker> -->
					<el-date-picker v-model="times" style="width: 350px" type="datetimerange" range-separator="至" start-placeholder="开始日期"
     					end-placeholder="结束日期" @change="changeTime" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm">
    				</el-date-picker>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">订单状态</span>
					<el-select v-model="searchObj.status" style="width:160px" @change="changeScene">
						<el-option v-for="(item, index) in orderStatusList" :label="item.label" :value="item.value" :key="index"></el-option>
					</el-select>
				</div>
				<template v-if="openlist">
				<template v-if="staticPath === '/'">
					<div :class="classNames+ '_search_con_item'">
						<span :class="classNames+ '_search_con_item_title'">授权手机号&nbsp;&nbsp;&nbsp;</span>
						<el-input placeholder="请输入授权手机号" v-model="searchObj.phone"></el-input>
					</div>
					<div :class="classNames+ '_search_con_item'">
						<span :class="classNames+ '_search_con_item_title'">购买手机号&nbsp;&nbsp;&nbsp;</span>
						<el-input placeholder="请输入手机号" v-model="searchObj.order_phone"></el-input>
					</div>
				</template>
				<div :class="classNames+ '_search_con_item'" v-else>
					<span :class="classNames+ '_search_con_item_title'">购买手机号&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入手机号" v-model="searchObj.phone"></el-input>
				</div>
              <!-- <div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">发货状态</span>
					<el-select v-model="searchObj.is_sendout" @change="changeScene">
						<el-option v-for="(item, index) in stateList" :label="item.label" :value="item.value" :key="index"></el-option>
					</el-select>
				</div> -->
                <div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">课程标题</span>
					<!-- <el-select v-model="searchObj.product_id" clearable filterable>
						<el-option v-for="(item, index) in productList" :label="item.title" :value="item.id" :key="index"></el-option>
					</el-select> -->
                    <selectScroll :requestFun="authorCourse" v-model="searchObj.product_id" @change="changeScene"></selectScroll>
				</div>
				<div :class="classNames+ '_search_con_item'" v-if="staticPath == '/wx/'">
					<span :class="classNames+ '_search_con_item_title'">推广人微信昵称&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入推广人微信昵称" v-model="searchObj.nickname"></el-input>
				</div>
				<div :class="classNames+ '_search_con_item'" v-if="staticPath == '/'">
					<span :class="classNames+ '_search_con_item_title'">推广人抖音昵称&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入推广人抖音昵称" v-model="searchObj.nickname"></el-input>
				</div>
				<div :class="classNames+ '_search_con_item'" v-if="staticPath == '/ks/'">
					<span :class="classNames+ '_search_con_item_title'">推广人快手昵称&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入推广人快手昵称" v-model="searchObj.nickname"></el-input>
				</div>
				<div :class="classNames+ '_search_con_item'">
					<span :class="classNames+ '_search_con_item_title'">购买人昵称&nbsp;&nbsp;&nbsp;</span>
					<el-input placeholder="请输入购买人昵称" v-model="searchObj.buyer_nickname"></el-input>
				</div>
				</template>

				<div :class="[classNames+ '_search_con_item', classNames+ '_oprtation']">
					<el-button type="primary" @click="searchRes">查询</el-button>
					<el-button type="primary" @click="exportExcel" :disabled="orderInfo.total === 0" v-if="operaBtnAuth.export">导出</el-button>
					<el-button style="border:none;" v-if="!openlist" icon="el-icon-arrow-down" @click="openlist=true">高级筛选</el-button>
					<el-button style="border:none;" v-if="openlist" icon="el-icon-arrow-up" @click="openlist=false">收起</el-button>
					<span class="total_sums">共{{orderInfo.total}}条</span>
				</div>
			</div>
			<uploadCsv :is_logistics="orderInfo.is_logistics"></uploadCsv>
			
		</div>
		<div :class="classNames+'_con'">
			<div :class="classNames+'_con_table'">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane is-dot v-for="(item, index) in stateList" :label="item.label" :name="item.label" :key="index">
						<span slot="label">
							  {{item.label}}
							<el-badge :hidden="!(item.value===0&&isbadge)" is-dot></el-badge>
						</span>
					</el-tab-pane>
				  </el-tabs>
				<el-table :data="orderInfo.list"
					:header-cell-style="{background: '#F5F7FA',color:'#454D53'}" :cell-style="cellStyle">
					<div slot="empty">
						<img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
					</div>
					<template v-for="(item, index) in headerList">
						<el-table-column :label="item.label" :prop="item.prop"
						:type="item.prop" :key="index" :width="item.width" :align="item.align" v-if="!(item.excludeList && item.excludeList.includes(staticPath))">
							<template slot-scope="scope">
								<div v-if="item.prop === 'status'">
									<div v-if="scope.row.is_sendout ===1 " class="buy">已发货</div>
									<div v-if="scope.row.is_sendout == 0" class="buy refund1">待发货</div>
								</div>
								<div v-else-if="item.prop === 'product_title'">
									<div :class="classNames+'_empty'"></div>
									<div :class="classNames+'_item'">
										<span style="min-width:220px">订单编号：{{scope.row.order_no}}</span>
										<span>支付时间：{{scope.row.pay_time||'--'}}</span>
										<span>订单状态：{{scope.row.status_name||'--'}}</span>
									</div>
									{{scope.row[item.prop]}}
								</div>
								<div v-else-if="item.prop === 'nick_nake'" class="header_avatar">
									<el-avatar size="small" v-if="scope.row.avatar_url" :src="scope.row.avatar_url"></el-avatar>
									{{scope.row.nick_nake}}
								</div>
								<div v-else>{{scope.row[item.prop]}}</div>
							</template>
						</el-table-column>
					</template>
					<el-table-column label="操作" width="90">
						<template slot-scope="scope">
							<span @click="capitaletails(scope.row)" :class="classNames+'_operation_title'" v-if="operaBtnAuth.detail">详情</span>
                            <span @click="addLogistics(scope.row)" :class="classNames+'_operation_title'" v-if="scope.row.is_sendout === 0">发货</span>
                            <span @click="previewLogistics(scope.row)" :class="classNames+'_operation_title'" v-if="scope.row.is_sendout === 1">查看物流</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<Pagination @change="changeSize" :total="orderInfo.total" ref="pagination" v-if="showPagination" v-model="searchObj.page"></Pagination>
		</div>
		<drawer v-model="drawerFlag" :id="detail_id"></drawer>
        <el-dialog
            :title="detail_id? '物流信息': '请填写物流信息'"
            :visible.sync="dialogVisible"
            width="400px"
        >
            <el-form :rules="sendRules" :model="sendParams" ref="sendRuleForm" label-width="80px">
                <el-form-item prop="code" label="快递公司">
                    <el-select v-model="sendParams.code" style="width: 100%">
                        <el-option v-for="item in expressCompanyList" :key="item.code" :value="item.code" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="number" label="快递单号">
					<!-- @[copyClickType].native="copyWord" -->
                    <el-input v-model="sendParams.number" placeholder="请输入快递单号" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureFun">{{detail_id ? '更新信息': '确 定'}}</el-button>
            </span>
        </el-dialog>
	</div>
</template>

<script>
	import {
		data
	} from './data.js'
	import {
		mapState,
		mapActions
	} from 'vuex'
	import Pagination from '@/components/pagination/pagination.vue'
	import staticPathTitle,{ getBaseUrl } from '@/utils/baseUrl.js'
	import drawer from '@/components/drawer/drawer.vue'
    import selectScroll from '@/pages/dataCenter/selectScroll.vue'
    import { copyToClipboard } from '@/utils/index.js'
	import uploadCsv from './uploadCsv.vue'
	import { findBtnAuth } from '@/utils/utils.js'
	export default {
		name: 'Order',
		mixins: [data],
		data() {
			console.log(this.staticPath, '===')
			const obj = {}
			if(this.staticPath === '/') {
				obj.order_phone = ''
			}
			return {
				classNames: 'sendOrder',
				times: [],
				popHeaderList: [
					{
						prop: 'role',
						label: '角色'
					},
					{
						prop: 'profit',
						label: '收益'
					}
				],
				searchObj: {
					page:1,
					page_size:10,
					start_time: '',
					end_time:'',
					order_no: '',
					nickname: '',
					buyer_nickname: '',
					is_sendout:0,
					product_id: '',
					phone: '',
					status: 4,
					...obj
				},
				tableList: [],
				noDataName: 'empty',
				stateList: [
					{
						label: '全部',
						value: ''
					},
					{
						label: '待发货',
						value: 0
					},
					{
						label: '已发货',
						value: 1
					}
				],
				orderStatusList: [
					{
						label: '全部',
						value: -1
					},
					{
						label: '已购买',
						value: 4
					},
					{
						label: '已退款',
						value: 7
					},
					{
						label: '退款申请中',
						value: 11
					}
				],
				channelAccountList: [],
				drawerFlag: false,
				detail_id: '',
				openlist:false,
				productList: [],
                orderInfo: {
                    list: [],
                    total: 0
                },
                dialogVisible: false,
                sendParams: {
                    order_id: '',
                    code: '',
                    number: ''
                },
                sendRules: {
                    code: [
                        {
                            required: true,
                            message: '请选择快递公司',
                            trigger: 'change'
                        }
                    ],
                    number: [
                        {
                            required: true,
                            message: '请输入快递单号',
                            trigger: 'blur'
                        }
                    ]
                },
                expressCompanyList: [],
				activeName: '待发货',
				isbadge:false,//
				operaBtnAuth:{
					detail: false,
					export: false
				}
			}
		},
		created() {
			this.getOrderInfos(true)
            this.getExpressCompany()
		},
		components: {
			Pagination,
			drawer,
            selectScroll,
			uploadCsv
		},
		computed: {
			...mapState(['breadCrumbList']),
			...mapState("permission", ["menuList"]),
			cellStyle() {
				return {
					'padding': '54px 0 12px 0'
				}
			},
             copyClickType() {
                return this.detail_id ? 'click': ''
            },
			// 显示页码
			showPagination(){
				if(this.orderInfo.total > 0){
					return true
				}else{
					return false
				}
			}
		},
		watch: {
			orderInfo(){
				if(this.activeName=='待发货'){
					if(this.orderInfo.list.length>0){
						this.isbadge = true
					}else{
						this.isbadge = false
					}
				}
			},
			menuList: {
				deep: true,
				immediate: true,
				handler(newVal, oldVal) {
					if(newVal.length > 0) {
						this.getUserAuthBtn()
					}
				}
			}
		},
		methods: {
			...mapActions('export', ['createExportAPI']),
			...mapActions('withdrawal', ['logisticsList','authorCourse', 'expressCompany', 'sendout', 'editSendout']),
			handleClick(tab, event) {
				this.searchObj.is_sendout=this.stateList[tab.index].value
				this.getOrderInfos(true)
			  },
            copyWord() {
                copyToClipboard(this.sendParams.number)
                this.$message({
                    type: 'success',
                    duration: 3000,
                    message: '快递单号复制成功'
                })
            },
			capitaletails(row) {
				this.drawerFlag = true
				this.detail_id = row.id
			},
			changeSize(size) {
				this.searchObj.page = size
				this.getOrderInfos()
			},
			changeTime(value, a, b) {
				this.searchObj.start_time = this.times && this.times.length ? this.times[0] : ''
				this.searchObj.end_time = this.times && this.times.length ? this.times[1] : ''
			},
			async getOrderInfos(flag) {
				if(flag) {
					this.searchObj.page = 1
				}
				let res = await this.logisticsList(this.searchObj)
                this.orderInfo = {
                    list: res.list,
                    total: res.page_info.total_count,
					is_logistics: res.is_logistics
                }
			},
			searchRes() {
				this.noDataName = 'noData'
				this.getOrderInfos(true)
			},
			exportExcel() {
				const searchObj = {}
				for (const key in this.searchObj) {
					if (this.searchObj[key]) {
						searchObj[key] = this.searchObj[key]					
					}
				}
				const comeFrom = staticPathTitle[this.staticPath].value
				this.$confirm('5分钟内仅可导出一次,导出后可在导出记录中查看导出进度,导出成功的数据请在24小时内下载', '导出提示', {
					distinguishCancelAndClose: true,
					confirmButtonText: '导出',
					cancelButtonText: '取消',
					customClass: ''
				})
				.then(async () => {
					await this.createExportAPI({
						type: 4, // 1用户订单 2退款订单 3申诉订单 4发货订单 5线索订单
						search_params: {
							...searchObj,
							excel: 1,
							comeFrom: comeFrom
						}
					})
					this.$router.push({
						path:  this.staticPath + "exportHistory"
					})
				})
			},
            async getExpressCompany() {
                let res = await this.expressCompany()
                this.expressCompanyList = res
            },
			changeScene() {
				this.getOrderInfos(true)
				this.noDataName = 'noData'
			},
            addLogistics(row) {
                this.detail_id = ''
                this.sendParams = {
                    order_id: row.id,
                    code: '',
                    number: ''
                }
                this.dialogVisible = true
            },
            previewLogistics(row) {
                this.sendParams =  {
                    order_id: row.id,
                    code: row.express_code,
                    number: row.express_number
                },
                this.detail_id = row.id
                this.dialogVisible = true
            },
            sureFun() {
                this.$refs.sendRuleForm.validate(async (valid) => {
                    if(valid) {
                        await this[this.detail_id ? 'editSendout' : 'sendout'](this.sendParams)
                        this.dialogVisible = false
                        this.getOrderInfos()
                        this.$message({
                            type: 'success',
                            message: '添加成功'
                        })
                    }
                })
            },
			getUserAuthBtn(){
				const detailName = 'btn.order.detail'
				const detailBtn = findBtnAuth(this.menuList, item => item.route_name == detailName)
				if(!!detailBtn){
					this.operaBtnAuth.detail = true
				}
				
				const exportName = 'btn.sendOrder.export'
				const exportBtn = findBtnAuth(this.menuList, item => item.route_name == exportName)
				if(!!exportBtn){
					this.operaBtnAuth.export = true
				}
			}
		}
	}
</script>
<style lang="less">
	@classNames: sendOrder;
	.@{classNames} {
		.el-table::before {
			background-color: transparent;
		}
		.tr-hide {
			display: none;
		}
		.@{classNames}_operation_title {
			text-align: right;
			display: block;
			margin-right: 12px;
			color: #1989FA;
			font-size: 14px;
			cursor: pointer;
		}
	}
	.@{classNames}_oprtation {
		flex: 1 0 auto;
		display: flex;
		justify-content:flex-start;
		position: relative;
		.el-button--primary {
			margin:0 6px;
		}
		.total_sums{
			position: absolute;
			top:50%;
			transform: translateX(-50%);
			right: 0;
			font-weight: normal;
			color: #606266;
		}
	}

	.@{classNames}_detailed {
		padding: 20px 24px;
		width: 400px;
		box-sizing: border-box;
		.el-dialog__body {
			padding: 0;
		}
		.el-dialog__header {
			padding: 0 0 13px 0;
			.el-dialog__title {
				font-size: 16px;
				font-weight: 500;
				color: #485059;
			}
		}
	}
	.@{classNames}_con_table {
		.@{classNames}_empty {
			position: absolute;
			top: 0px;
			left: 0;
			width: 1000px;
			height:10px;
			background: #fff;
			z-index: 100;
		}
		.@{classNames}_item {
			position: absolute;
			top: 10px;
			left: 0;
			width: 1000px;
			padding: 0 12px;
			height: 32px;
			background: #F5F7FA;
			color: #888a95;
    		font-size: 12px;
			line-height: 32px;
			display: flex;
			justify-content: flex-start;
			z-index: 1000;
			span {
				&:not(:first-child) {
					margin-left: 12px;
				}
			}
		}
		.buy {
			width: 66px;
			height: 24px;
			border-radius: 12px;
			border: 1px solid #5ADDB3;
			font-size: 14px;
			color: #2DC695;
			line-height: 24px;
			text-align: center;
			
		}
		.refund{
			color: #888a95;
			border: 1px solid #888a95;

		}
		.refund1{
			color: orange;
			border: 1px solid orange;
		
		}
		.header_avatar{
			display: flex;
			align-items: center;
			justify-content: left;
			span{
				width: 28px;
				height: 28px;
				flex: none;
				margin-right: 10px;
			}
			
		}
	}
</style>
<style lang='less' scoped>
	@classNames: sendOrder;

	.@{classNames} {
		display: flex;
		flex-direction: column;
		height: 100%;
		.@{classNames}_statistics {
			flex-shrink: 0;
			padding: 20px 0;
			box-sizing: border-box;
			span {
				font-size: 16px;
				font-weight: 600;
				color: #485059;
				line-height: 16px;
				&:last-child {
					margin-left: 60px;
				}
			}
		}
		.@{classNames}_search {
			display: flex;
			flex-shrink: 0;
			padding-bottom: 20px;
			box-sizing: border-box;
			border-bottom: 1px solid #F8F8FB;
			flex-wrap: wrap;
			justify-content: space-between;
			.@{classNames}_search_con {
				display: flex;
				flex-wrap: wrap;
				.@{classNames}_search_con_item {
					display: flex;
					align-items: center;
					margin-right: 16px;
					margin-bottom: 12px;
					
					.@{classNames}_search_con_item_title {
						white-space: nowrap;
						font-size: 14px;
						color: #606266;
						margin-right: 12px;
					}
				}
			}
		}

		.@{classNames}_con {
			flex: 1;
			display: flex;
			flex-direction: column;
		}
	}
</style>
